import { useRouter } from 'next/router';
import { useEffect, useState, useRef } from 'react';
import { ParsedUrlQuery } from 'querystring';

export function getQueryParams(): ParsedUrlQuery {
  const newUrlQuery = new URLSearchParams(window.location.search);
  const queryObject: ParsedUrlQuery = {};

  // Convert URLSearchParams to object
  newUrlQuery.forEach((value, key) => {
    queryObject[key] = value;
  });

  return queryObject;
}

export function useQueryParams(): ParsedUrlQuery {
  const router = useRouter();
  const [urlQuery, setUrlQuery] = useState<ParsedUrlQuery>(router.query);
  const lastSearchString = useRef<string>('');

  useEffect(() => {
    const currentSearchString = window.location.search;

    // Only update if the search string has actually changed
    if (currentSearchString !== lastSearchString.current) {
      lastSearchString.current = currentSearchString;

      try {
        setUrlQuery(getQueryParams());
      } catch (__error) {
        // Fallback to router.query if URL parsing fails
        setUrlQuery(router.query);
      }
    }
  }, [router.asPath, router.isReady]);

  return urlQuery;
}
